import React, { FC } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Collapse, CollapseItem } from '@ucheba/ui/components/Collapse/desktop'
import { capitalizeFirstLetter } from '@ucheba/utils/helpers/string'
import { IStudyProgram } from '../types'

const StudyProgram: FC<IStudyProgram> = (props) => {
  const { blockDescriptions } = props

  return (
    <div>
      <Heading h3='Программа обучения' spacing='large' />

      <Collapse>
        {blockDescriptions.map((item, key) => (
          <CollapseItem fontSize='h4' key={key} title={capitalizeFirstLetter(item.title)}>
            <Text firstLetterUppercase>{item.description}</Text>
          </CollapseItem>
        ))}
      </Collapse>
    </div>
  )
}

export default StudyProgram
